var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-list-tile',[_c('v-list-tile-avatar',[_c('v-icon',[_vm._v(_vm._s(_vm.icon))])],1),_c('v-list-tile-content',[_c('v-list-tile-title',[_vm._v(_vm._s(_vm.title))])],1),_c('v-list-tile-action',[_vm._t("default")],2)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }